import React, { ComponentProps, CSSProperties, ReactNode } from 'react'
import { Text } from 'react-native'

import styles from './styles'

type Props = ComponentProps<typeof Text> & {
  children: ReactNode
  bold?: boolean
}

const HGText = (props: Props) => {
  const { children, style, bold } = props

  const textStyles = [
    styles.text,
    ...(bold ? [styles.bold] : []),
    ...(style ? [style] : []),
  ]

  // if (tailwindStyle && tailwindStyle.length) {
  //   textStyles.concat(tailwindStyle)
  // }

  return (
    <Text {...props} style={textStyles}>
      {children}
    </Text>
  )
}

HGText.defaultProps = {
  bold: false,
}

export default HGText
